import {
  findIndex,
  map,
  update,
  invoker,
  defaultTo,
  compose,
  curry,
  is
} from "ramda";

//:: (a -> Boolean) -> Lens [a] a
export const lensMatching = pred => (toF => entities => {
    const index = findIndex(pred, entities);
    return map(entity => update(index, entity, entities),
                 toF(entities[index]));
});


export const toFixed = curry((decimalsInFloat, value) => compose(invoker(1, 'toFixed')(decimalsInFloat), defaultTo(0))(value))

export const round = (value) => (is(Number, value) && value > 0) ? Math.floor(value * 100) / 100 : 0
